module.exports = __webpack_public_path__ + "img/Abfahrk_Maengel.5c3622f5.svg";